<template>
  <div>
    <el-form :model="queryForm" :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="原协议标题" prop="protocolTitle">
            <el-input type="text" v-model="queryForm.protocolTitle" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型" prop="protocolType">
            <DictionarySelect v-model="queryForm.protocolType" :lazy="true" :excludeKeys="['1']" tableCode="PROTOCOL_APPLY_TYPE"></DictionarySelect>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <SearchButton @search="search" @reset="resetSearchForm" @expand="e => expand = e">
          </SearchButton>
        </el-col>
      </el-row>
      <el-row v-if="expand">
        <el-col :span="6">
          <el-form-item label="协议编号" prop="protocolId">
            <el-input type="text" v-model="queryForm.protocolId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="原协议批次" prop="batchNo">
            <el-input type="text" v-model="queryForm.batchNo" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请时间" prop="createTimeRange">
            <DateRangePicker v-model="queryForm.createTimeRange"></DateRangePicker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="汇款时间" prop="remitTimeRange">
            <DateRangePicker v-model="queryForm.remitTimeRange"></DateRangePicker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="loading"
      height='calc(100vh - 285px)'>
      <el-table-column prop="applyId" width="180" label="退补款编号">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.applyId">
            <span class="link" @click="toDetail(scope.row)">{{ scope.row.applyId }}</span>
          </TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="applyTypeName" width="80" label="类型"></el-table-column>
      <el-table-column prop="createTime" width="100" label="申请时间">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="relationProtocolTitle" label="原协议标题" min-width="160">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.relationProtocolTitle"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="relationTotalHelpAmount" width="110" label="原救助费用" align="right">
        <template slot-scope="scope">
          <span>{{scope.row.relationTotalHelpAmount ? parseFloat(scope.row.relationTotalHelpAmount).toFixed(2) : '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="relationBatchNo" width="70" label="批次" align="center"></el-table-column>
      <el-table-column prop="childSum" width="120" label="退补款人数" align="right"></el-table-column>
      <el-table-column prop="totalHelpAmount" width="110" label="退补款费用" align="right">
        <template slot-scope="scope">
          <span>{{scope.row.totalHelpAmount ? parseFloat(scope.row.totalHelpAmount).toFixed(2) : '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="progressCodeName" label="协议状态" width="160"></el-table-column>
      <el-table-column v-if="active == 'all' || active == 'done'" prop="remitTime" width="160" label="汇款时间">
        <template slot-scope="scope">
          <span v-if="scope.row.remitTime">{{ parseTime(scope.row.remitTime, '{y}-{m}-{d}') }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column width="110" fixed="right" label="协议下载">
        <template slot-scope="scope">
          <el-button v-if="scope.row.nodeCode > 2 && scope.row.downloadEnable == 1 && scope.row.publishStatus == 2" type="primary" size="mini" plain @click="downloadProtocol(scope.row)">协议下载</el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <Pageination
      @sizeChange="handleSizeChange"
      @currentChange="handleCurrentChange"
      :currentPage="queryParams.pageNO"
      :total="pageTotal">
    </Pageination>
  </div>
</template>

<script>
import {
  getProtocolDataListByCond,
  downloadRefundProtocol
} from "@/util/api.js";
import HospitalSelect from "@/components/business/HospitalSelect";
import TableCellWordBreak from "@/components/business/TableCellWordBreak"
import DateRangePicker from "@/components/business/DateRangePicker";
import NumberRange from "@/components/business/NumberRange";
import NumberInput from "@/components/business/NumberInput";
import DictionarySelect from "@/components/business/DictionarySelect";

import SearchButton from "@/components/business/SearchButton";
import Pageination from "@/components/business/Pageination";

export default {
  components: {
    HospitalSelect,
    DateRangePicker,
    TableCellWordBreak,
    NumberRange,
    NumberInput,
    DictionarySelect,
    SearchButton,
    Pageination,
  },
  props: {
    active: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {
      tableHeight:'',
      loading: false,
      expand: false,
      queryForm: {},
      queryParams: {
        pageNO: 1,
        pageSize: 10,
        searchCond: {}
      },
      tableData: [],
      pageTotal: 0
    };
  },
  mounted () {
    this.queryParams.pageNO = 1;
    this.loadData();
  },
  watch: {
    '$route.query.q' : {
      deep: true,
      handler () {
        this.queryParams.pageNO = 1;
        this.loadData();
      }
    }
  },
  methods: {
    search () {
      this.queryParams.pageNO = 1;
      this.loadData();
    },
    loadData () {
      this.loading = true
      // 申请时间查询条件
      if (this.queryForm.createTimeRange && this.queryForm.createTimeRange.length > 1) {
        this.queryForm.createTimeBegin = this.queryForm.createTimeRange[0];
        this.queryForm.createTimeEnd = this.queryForm.createTimeRange[1];
      }
      // 汇款时间查询条件
      if (this.queryForm.remitTimeRange && this.queryForm.remitTimeRange.length > 1) {
        this.queryForm.remitTimeBegin  = this.queryForm.remitTimeRange[0];
        this.queryForm.remitTimeEnd = this.queryForm.remitTimeRange[1];
      }
      
      this.queryParams.searchCond = Object.assign({}, this.queryForm);

      this.queryParams.searchCond.applyType = "2,3";
      this.queryParams.searchCond.publishStatus = 2;

      let httpRequest = getProtocolDataListByCond(this.queryParams);
      this.loading = true;
      httpRequest.then(res => {
        this.tableData = !res.responseData.modelDatal ? res.responseData.modelData: [];
        this.pageTotal = res.responseData.total;
        this.loading = false
      })
    },
    downloadProtocol (row) {
      downloadRefundProtocol(row.applyType > 1 ? row.applyId : row.protocolId, row.applyType).then(data => {
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', row.protocolTitle + '.pdf');
        document.body.appendChild(link);
        link.click();
      })
    },
    resetSearchForm() {
      this.queryForm = {};
      this.queryParams.pageNO = 1;
      this.loadData();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNO = val
      this.loadData()
    },
    openScreenFun() {
      this.openScreen1 = !this.openScreen1;
    },
    toDetail(row) {
      this.$router.push('/protocol/refund/' + row.protocolId + '/' + row.applyType + '/' + row.applyId + '/y');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
</style>



// WEBPACK FOOTER //
// src/pages/protocol/refund/RefundProtocolTable.vue